import gql from 'graphql-tag';

export const ExportListOpportunityReconciliation = gql`
  query CMS_listOpportunityReconciliation(
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
    $cityIds: [ID]
    $completedAtEnd: Datetime
    $completedAtStart: Datetime
    $countryIds: [ID]
    $createdAtEnd: Datetime
    $createdAtStart: Datetime
    $finalMoveInDateEnd: Datetime
    $finalMoveInDateStart: Datetime
    $finalMoveOutDateEnd: Datetime
    $finalMoveOutDateStart: Datetime
    $invoiceNumber: NonEmptyString
    $landlordBookingStatuses: [LandlordBookingStatus]
    $landlordIds: [ID]
    $markets: [OpportunityDestinationMarketEnum]
    $propertyIds: [ID]
    $referenceId: NonEmptyString
    $secondaryLandlordBookingStatus: SecondaryLandlordBookingStatus
    $opportunityIds: [ID]
  ) {
    listOpportunityReconciliation(
      pageNumber: $pageNumber
      pageSize: $pageSize
      cityIds: $cityIds
      completedAtEnd: $completedAtEnd
      completedAtStart: $completedAtStart
      countryIds: $countryIds
      createdAtEnd: $createdAtEnd
      createdAtStart: $createdAtStart
      finalMoveInDateEnd: $finalMoveInDateEnd
      finalMoveInDateStart: $finalMoveInDateStart
      finalMoveOutDateEnd: $finalMoveOutDateEnd
      finalMoveOutDateStart: $finalMoveOutDateStart
      invoiceNumber: $invoiceNumber
      landlordBookingStatuses: $landlordBookingStatuses
      landlordIds: $landlordIds
      markets: $markets
      propertyIds: $propertyIds
      referenceId: $referenceId
      secondaryLandlordBookingStatus: $secondaryLandlordBookingStatus
      opportunityIds: $opportunityIds
    ) {
      edges {
        id
        referenceId
        finalPrice
        createdAt
        completedAt
        finalMoveInDate
        finalMoveOutDate
        landlordApplicationSystem
        landlordBookingStatus
        landlordApplicationId
        secondaryLandlordBookingStatus
        ownedBy
        city {
          name
          country {
            name
            market
            billingCycle
          }
        }
        student {
          firstName
          lastName
          dateOfBirth
          destinationUniversity
          emailAddress
          gender
          nationality
          passportFirstName
          passportLastName
          passportMiddleName
          passportNumber
          phoneNumber
          city
        }
        booking {
          commissionData
        }

        opportunityNote {
          reconciliationNote
        }
        tenancyLength {
          days
          weeks
        }
        completedXbooking {
          landlordId
          unitPrice
          roomName
          currency
          propertyName
          landlordName
          commission {
            invoiceNumber
            value
            actualInvoicedValue
            bonusCalculationType
            bonusCalculationValue
            bonusValue
            calculationType
            calculationValue
            currency
            firstInvoicedAt
            id
            lastInvoicedAt
            outstandingClaimValue
            totalCommissionValue
          }
        }
      }
      pageInfo {
        numPages
        hasPreviousPage
        hasNextPage
      }
      totalCount
    }
  }
`;
